
import React, {useEffect, useState} from "react";
import {Checkbox, FormControlLabel, InputAdornment, TextField} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";

const CategoryItemGroupedParameter = ({
                                          id,
                                          field,
                                          fieldValue,
                                          validator,
                                          onChange,
                                          handleValueChange,
                                          width,
                                          size,
                                          errorInitial,
                                          forceShowError}) =>
{
    const setInitialValue = () => {
        if (field.type === "Boolean" || field.type === 4) {
            return "NO";
        }
        return "";
    };


    const [value, setValue] = useState(setInitialValue);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (field.type === "Boolean" || field.type === 4) {
            handleValueChange(field, "NO");
        }
    }, [field, handleValueChange]);


    useEffect(() => {
        setValue(fieldValue ?? '');
    }, [fieldValue])

    useEffect(() => {
        if (forceShowError && !value) {
            const errorMessage = (field.type === "Text" || field.type === 1
                || field.type === "Number" || field.type === 2)
                ? "This field is required"
                : "Please select an option";
            setError(errorMessage);
        }
    }, [forceShowError, value, field.type]);

    const handleChange = (e) => {
        const { value: newValue } = e.target;
        const errorMessage = (field.type === "Text" || field.type === 1
            || field.type === "Number" || field.type === 2)
            ? validator(newValue)
            : (newValue === '' ? "Please select an option" : false);
        setValue(newValue);
        handleValueChange(field, newValue);
        setError(errorMessage);

        onChange(!errorMessage);
    }

    const handleCheckboxChange = (e) => {
        const newValue = !!e.target.checked ? "YES" : "NO";
        handleValueChange(field, newValue);
        setValue(newValue);
        onChange(true);
    }

    if (field.type === "Text" || field.type === 1
        || field.type === "Number" || field.type === 2) {
        return (
            <TextField
                id={`${id}-${field.id}`}
                label={field.displayName}
                error={errorInitial === false || !!error}
                required
                helperText={error ? error : ""}
                value={value}
                onChange={handleChange}
                sx={{ width: width ?? {xs: '250px !important', sm: '300px !important'} }}
                size={!!size ? size : "medium"}
                slotProps={{
                    input: { endAdornment: <InputAdornment position="end">{field.uom}</InputAdornment> }
                }}
            />
        )
    } else if (field.type === "Enumeration" || field.type === 3) {
        return (
            <TextField
                id={`${id}-${field.id}`}
                label={field.displayName}
                error={errorInitial === false || !!error}
                required
                select
                helperText={error ? error : ""}
                value={value}
                onChange={handleChange}
                sx={{ width: width ?? {xs: '250px !important', sm: '300px !important'}  }}
                size={!!size ? size : "medium"}
            >
                {(field.enumOptions ?? []).map((option, i) => (
                    <MenuItem key={i} value={option} sx={{ textAlign: 'left' }}>
                        {option}
                    </MenuItem>
                ))}
            </TextField>
        )
    } else if (field.type === "Boolean" || field.type === 4) {
        return (
            <FormControlLabel
                id={`${id}-${field.id}`}
                control={<Checkbox checked={value === "YES"} onChange={handleCheckboxChange} />}
                label={field.displayName}
            />
        )
    }
}

export default CategoryItemGroupedParameter;